import { render, staticRenderFns } from "./PlayMedia.vue?vue&type=template&id=28b41776&scoped=true"
import script from "./PlayMedia.vue?vue&type=script&lang=js"
export * from "./PlayMedia.vue?vue&type=script&lang=js"
import style0 from "./PlayMedia.vue?vue&type=style&index=0&id=28b41776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b41776",
  null
  
)

export default component.exports